export default __webpack_public_path__ + "static/media/fortbildung.3711d154.svg";